import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://qnqxqxhlxaqbryapqmvd.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'PLACEHOLDER_ADD_YOUR_ANON_KEY_IN_ENV';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
export const supabaseAnonKeyExport = supabaseAnonKey;
